import { usePlayersStore, useSessionStore } from "@/stores";
import type { Player } from "@/types";
export function updatePlayer({
  index,
  property,
  value,
}: {
  index: number;
  property: keyof Player;
  value: unknown;
}) {
  const session = useSessionStore();
  if (!session.isPlayerOrSpectator) return;
  const playersStore = usePlayersStore();
  const player = playersStore.players[index];
  if (!player) return;
  playersStore.update({ player, property, value, isFromSocket: true });
}
